module.exports = __webpack_public_path__ + "static/ribbon_options-2b8bf408e896142a7179757dd48fea90.png";